import React from "react";
import fire from "./components/fire";
import { HashRouter as Router } from "react-router-dom";
import { Switch, Route } from "react-router-dom";
import Home from "./components/Home";
import Graficos from "./components/Graficos";
import Agrupaciones from "./components/Agrupaciones";
import SearchGen from "./components/SearchGen";
import Search from "./components/Search";
import Resumen from "./components/Resumen";
import Menu from "./components/Menu";
import Footer from "./components/Footer";
import Clasificacion from "./components/Clasificacion";
import ClasificacionPreli from "./components/ClasificacionPreli";
import ClasificacionCuartos from "./components/ClasificacionCuartos";
import ClasificacionSemi from "./components/ClasificacionSemi";
import Tabla from "./components/Tabla";
import Missed from "./components/Missed";
import Inicio from "./components/Inicio";
import { fechas } from "./utils/helpers.js";
import { firma } from "./utils/helpers.js";

import * as moment from "moment";
import "moment/locale/es";
// Ignore
moment.suppressDeprecationWarnings = true;

class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			agr: [],
			tiempo: null,
			mainColor: "#F8AF2A"
		};
		// BINDINGS
		this.getMainColor = this.getMainColor.bind(this);
	}

	componentDidMount() {
		const ref = fire.database().ref("/agrupaciones/");
		ref.on("value", snapshot => {
			this.setState({
				agr: snapshot.val()
			});
		});
	}

	// FECHAS
	componentWillMount() {
		const ahora = moment().subtract(6, "h");

		// Borrar
		// const ahora = moment().add(24, "h");
		// End borrar

		const inicio = "01/09/2018";
		const final = "02/09/2018";

		let diferenciaFechas = () => {
			// Antes
			if (ahora.isBefore(inicio, "d")) {
				return {
					fase: `Quedan ${Math.abs(ahora.diff(inicio, "d"))} días`
				};
			}
			// Después
			if (ahora.isAfter(final, "d")) {
				return {
					fase: "Final"
				};
			} else {
				let restante = ahora.diff(inicio, "d");
				return fechas[restante + 1];
			}
		};

		let temp = diferenciaFechas();
		this.setState({
			tiempo: temp
		});
	}

	// COLOR PRINCIPAL
	getMainColor(ide) {
		let identificador = ide.split("_")[0];
		let rojo = "#E73729";
		let azul = "#298EF1";
		let amarillo = "#F8AF2A";
		let verde = "#379C5C";

		if (identificador === "cor") {
			this.setState({
				mainColor: rojo
			});
		}
		if (identificador === "chi") {
			this.setState({
				mainColor: azul
			});
		}
		if (identificador === "com") {
			this.setState({
				mainColor: amarillo
			});
		}
		if (identificador === "cua") {
			this.setState({
				mainColor: verde
			});
		}
	}

	render() {
		return (
			<div>
				<Menu mainColor={this.state.mainColor} tiempo={this.state.tiempo} />{" "}
				<Router>
					<Switch>
						<Route
							exact
							path="/"
							render={props => (
								<ClasificacionSemi
									{...props}
									agrupaciones={this.state.agr}
									tiempo={this.state.tiempo}
									mainColor={this.state.mainColor}
									getMainColor={this.getMainColor}
								/>
							)}
						/>
						<Route
							exact
							path="/clasificacionpreliminares"
							render={props => (
								<ClasificacionPreli
									{...props}
									agrupaciones={this.state.agr}
									tiempo={this.state.tiempo}
									mainColor={this.state.mainColor}
									getMainColor={this.getMainColor}
								/>
							)}
						/>
						{/* CLASIFICACIÓN DEL SABADO */}
						<Route
							exact
							path="/clasificacioncuartos"
							render={props => (
								<ClasificacionCuartos
									{...props}
									agrupaciones={this.state.agr}
									tiempo={this.state.tiempo}
									mainColor={this.state.mainColor}
									getMainColor={this.getMainColor}
								/>
							)}
						/>
						{/* CLASI DEL LUNES */}
						<Route
							exact
							path="/clasificacionsemifinales"
							render={props => (
								<ClasificacionSemi
									{...props}
									agrupaciones={this.state.agr}
									tiempo={this.state.tiempo}
									mainColor={this.state.mainColor}
									getMainColor={this.getMainColor}
								/>
							)}
						/>
						<Route
							exact
							path="/clasificacion"
							render={props => (
								<ClasificacionSemi
									{...props}
									agrupaciones={this.state.agr}
									tiempo={this.state.tiempo}
									mainColor={this.state.mainColor}
									getMainColor={this.getMainColor}
								/>
							)}
						/>
						<Route
							exact
							path="/tabla"
							render={props => (
								<Tabla
									{...props}
									agrupaciones={this.state.agr}
									tiempo={this.state.tiempo}
									mainColor={this.state.mainColor}
									getMainColor={this.getMainColor}
								/>
							)}
						/>
						<Route
							exact
							path="/resumen"
							render={props => (
								<Resumen
									{...props}
									agrupaciones={this.state.agr}
									tiempo={this.state.tiempo}
									mainColor={this.state.mainColor}
								/>
							)}
						/>
						<Route
							path="/agrupaciones/:ide"
							render={props => (
								<Agrupaciones
									{...props}
									agrupaciones={this.state.agr}
									tiempo={this.state.tiempo}
									mainColor={this.state.mainColor}
									getMainColor={this.getMainColor}
								/>
							)}
						/>
						<Route component={Missed} />
						) }
					</Switch>
				</Router>
				<Footer />
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js